module.exports = __webpack_public_path__ + "static/media/clap.06bc360d.ogg";